import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-request-access-dialog',
    templateUrl: './request-access-dialog.component.html',
    styleUrls: ['./request-access-dialog.component.css'],
    standalone: false,
})
export class RequestAccessDialogComponent {
    constructor(private dialogRef: MatDialogRef<RequestAccessDialogComponent>) {}

    cancel() {
        this.dialogRef.close();
    }

    acceptPublish() {
        this.dialogRef.close(true);
    }
}
